<template>
  <div class="gift-ideas">
    <div class="top-white-box"></div>
    <div class="top-gray-box">
        <h1>The Best Gift Buying Ideas</h1>
    </div>
    
    <Articles />
    
  </div>
</template>

<script>
// @ is an alias to /src
import Articles from '@/components/Articles.vue'
import settings from '@/settings'

export default {
  name: 'giftideas',
  created(){
      document.title = 'The Best Gift Buying Ideas for Everyone On Your List | ' + settings.siteNameCaps;
  },
  computed: {
    settings: function(){ return settings; }
  },
  components: {
    Articles
  }
}
</script>